const en = {
  SideNavBar: {
    logout: 'logout',
  },
  StationListHeader: {
    Sites: 'Sites',
    Site: 'Site',
  },
  StationList: {
    Empty: 'No sites here',
  },
  StationListItem: {
    New: 'New',
  },
  IFRangePicker: {
    Min: 'Min',
    Max: 'Max',
    Ok: 'OK',
  },
  IFFilter: {
    ClearButton: 'Clear',
    or: ' or ',
    Ascending: 'Ascending',
    Descending: 'Descending',
    Download: 'Download',
  },
  IFDialog: {
    Cancel: 'Cancel',
  },
  ChargePointLogListItem: {
    callID: 'Call ID',
  },
  AddChargePointModal: {
    Title: 'Add Station',
    StationIDText: 'Station ID',
    StationNameText: 'Station Name',
    ButtonText: 'Done',
    Required: 'Required',
  },
  ConfigurationListItem: {
    type: 'Type',
    description: 'Description',
    done: 'Done',
    cancel: 'Cancel',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    GenerateLink: 'generate link for connector',
  },
  ConfigurationList: {
    EditSuccess: 'Configuration edited successfully',
    EditFail: 'Failed to edit configuration',
    RebootRequired: 'Station reboot required',
  },
  ConfigurationModal: {
    title: 'Configuration',
    lastUpdated: 'last updated',
    notAvailable: 'Not available',
  },
  MoveStationModal: {
    Title: 'Move Station',
    AcceptButtonText: 'Move',
  },
  ConnectorListItem: {
    kW: 'kW',
    Actions: 'Actions',
    StartTx: 'Start Tx',
    StopTx: 'Stop Tx',
    Unlock: 'Unlock',
    RefreshStatus: 'Request status update',
    ReserveConnector: 'Reserve',
    CancelConnectorReservation: 'Cancel reservation',
    SocLimit: 'SOC',
  },
  ConnectorList: {
    Empty: 'No connectors found',
  },
  FirmwareModal: {
    Title: 'Firmware',
    UpdateText: 'Update Firmware',
    DragAndDropText: 'Drag & Drop firmware file here',
    UpdateButtonText: 'Update',
    CurrentFirmwareText: 'Current Firmware',
    firmwareURL: 'URL ',
    Required: 'Required*',
    Or: 'Or',
  },
  AddStationModal: {
    Add: 'Add',
    AddSite: 'Add Site',
    SiteName: 'Site Name',
    StreetName: 'Street Name',
    City: 'City',
    Coordinates: 'Coordinates',
    Access: 'Access',
    Public: 'Public',
    Private: 'Private',
    Required: 'Required',
  },
  StationDetailsModal: {
    Done: 'Done',
    Cancel: 'Cancel',
    Edit: 'Edit',
    StreetName: 'Street Name',
    City: 'City',
    Coordinates: 'Coordinates',
    Delete: 'Delete',
    DeleteDialogTitle: 'Delete Site',
    DeleteDialogSubtitle:
      'Please type the name of the site to confirm deletion',
    DeleteButtonText: 'Delete',
    Public: 'Public',
    Private: 'Private',
    Access: 'Access',
    SuccessMessage: 'Station updated successfully',
  },
  Login: {
    Welcome: 'Welcome Back!',
    EmailAddress: 'Email Address',
    Password: 'Password',
    EmailAddressPlaceholder: 'example@example.com',
    PasswordPlaceholder: 'Password',
    SignIn: 'Sign In',
    ForgotPassword: 'Forgot password?',
    PasswordError: 'Password must be at least 8 characters',
    EmailError: 'Please enter a valid email',
    Required: 'Required*',
    TwoFactorTitle: 'Two-Factor Authentication',
    TwoFactorDescription: 'Enter the 6-digit code from your authenticator app.',
    Verify: 'Verify',
    SetupTwoFactorDescription:
      'Infinity EV requires you to set up two-factor authentication.',
    SetupTwoFactorTitle: 'Set Up Two-Factor Authentication',
    ScanBarcode: 'Scan this Barcode',
    ScanBarcodeDescription: 'Use your authenticator app to scan this barcode.',
    ManualKeyHint: 'Or, enter the following code manually instead.',
    DownloadAuthenticatorDescription:
      'Install an authenticator app like Google Authenticator, Microsoft Authenticator, or 1Password.',
    DownloadAuthenticator: 'Download an Authenticator App',
    Continue: 'Continue',
    TwoFactorSetupComplete: 'Two-factor setup complete, please login',
  },
  ChargePointDetails: {
    Connectors: 'Connectors',
    ConfigurationButtonText: 'Configuration',
    ChargingProfileButtonText: 'Charging Profile',
    DiagnosticsButtonText: 'Diagnostics',
    FirmwareButtonText: 'Firmware',
    MoveButtonText: 'Move',
    DeleteButtonText: 'Delete',
    CancelButtonText: 'Cancel',
    DoneButtonText: 'Done',
    HardResetButtonText: 'Hard',
    SoftResetButtonText: 'Soft',
    ResetButtonText: 'Reset',
    EditButtonText: 'Edit',
    FilterLogsBy: 'Filter Logs By',
    DeleteDialogTitle: 'Delete Station',
    DeleteDialogSubtitle:
      'Please type the ID of the station to confirm deletion',
    ResetDialogTitle: 'Reset Station',
    HardResetDialogSubtitle:
      'Are you sure you want to reset the station? Any running charging sessions will be stopped.',
    SoftResetDialogSubtitle: 'Are you sure you want to reset the station?',
    BothResetDialogSubtitle:
      'Are you sure you want to reset the station? In case of a hard reset, any running charging sessions will be stopped.',
    SerialNumber: 'Serial number',
    Model: 'Model',
    Vendor: 'Vendor',
    FirmwareVersion: 'Firmware version',
    OCPPVersion: 'OCPP version',
    IMSI: 'IMSI',
    ICCID: 'ICCID',
    ActivateButtonText: 'Activate',
    lastUpdated: 'last updated',
    ClearCache: 'Clear Cache',
    NotvisibleInApp: 'Not visible in App',
    VisibleInApp: 'Visible in App',
    Terminal: 'Terminal',
    MeterValue: 'Meter value',
    ErrorCode: 'Error code',
    VendorErrorCode: 'Vendor error code',
    VendorId: ' Vendor ID',
    ChargePointUptimeFilter: 'Select date range',
    ConnectorsUtilizationFilter: 'Select date range',
    NoResultsFound: 'No results found',
    AlertButtonText: 'Alerts',
    OperatorUserActionsFilter: 'Filter Operator User Actions by',
    EditingOperatorUser: 'You',
    Details: 'Details',
    DownloadQr: 'Download QR code',
  },
  OperatorUserActions: {
    EditingAdmin: 'You',
    AdminPronoun: 'your',
    from: 'from',
    Changed: 'changed',
    Removed: 'removed',
    Created: 'created',
    Deleted: 'deleted',
    Activated: 'activated',
    Deactivated: 'deactivated',
    Invited: 'invited',
    Unblocked: 'unblocked',
    Moved: 'moved',
    To: 'to',
    RemoteStartTransaction: 'Remote Start Transaction',
    Make: 'Make',
    On: 'on',
    Preformed: 'performed',
    OperatorUserActionNoRecord: 'No records to display',
    Added: 'added',
    Emails: 'emails',
  },
  ResetPassword: {
    Header: 'Reset Password',
    Email: 'Email Address',
    EmailAddressPlaceholder: 'example@example.com',
    EmailError: 'Please enter a valid email',
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
    Reset: 'Reset',
    PasswordMismatch: 'Passwords do not match',
    PasswordError: 'Password must be at least 12 characters',
    ModalTitle: 'Confirm Password Reset',
    ModalSubTitle: 'Please enter the verification code sent to',
    PinValidationString: '0123456789',
    ModalButtonText: 'Confirm',
    ResetPasswordSuccess: 'Password was reset successfully',
    Required: 'Required*',
    CodeNotSentText: 'Did not get your code? ',
    ResendText: 'Resend code',
    ResendWithTimer: 'Resend in',
    PasswordLowercase: 'Password must contain at least one lowercase letter.',
    PasswordUppercase: 'Password must contain at least one uppercase letter.',
    PasswordNumber: 'Password must contain at least one number.',
    PasswordSymbol: 'Password must contain at least one symbol.',
  },
  StationsPage: {
    stationsTextFieldPlaceholder: 'Filter sites by',
  },
  ChargePointTab: {
    Inactive: 'Inactive',
    Connecting: 'Connecting',
  },
  emptyStates: {
    addStation: 'Add Station',
    addSite: 'Add Site',
    addCard: 'Add Card',
    noSiteshere: 'No Sites here',
    noCardsHere: 'No Cards here',
    stationEmptySites: 'Looks like you have no Sites',
    CardsEmpty: 'Looks like you have no Cards',
    noStationsSite: 'Looks like you have no Stations in',
    thisSite: 'this Site',
    dashboard: `Start building your dashboard by adding a new`,
    newSite: 'site',
    newChargingToken: 'charging token',
    filterNoSites: 'Filter does not match any sites, try a new search',
    filterNoCards: 'Filter does not match any cards, try a new search',
    filterNoLogs: 'Filter does not match any logs, try a new search',
    query: 'query',
    hi: 'Hi ',
    NoInternet: 'No Internet connection found. Please check your',
    NoConnection: 'No Connection',
    ConnectionTry: 'connection and try again',
    TryAgain: 'Try again',
    NoLogsHere: 'No logs here',
    NoConfigs: 'Configuration not yet fetched',
    NoDiagnostics: 'No diagnostics here',
    TryToRefresh: 'We cannot find anything here, try refreshing the list',
    NoActionsHere: 'No operator user actions here',
    filterNoActions:
      'Filter does not match any operator user actions, try a new search',
  },
  OperatorUserListItem: {
    cancelButton: 'Cancel',
    updateButton: 'Update',
    roleSelectorHeader: 'Roles',
    NoPermissionsSelected: 'No item selected',
  },
  OperatorUserList: {
    empty: 'No operator users found',
    deleteModalCancel: 'Cancel',
    deleteModalConfirm: 'Delete',
    deleteModalTitle: 'Confirm Delete',
    deleteModalText: 'Are you sure you want to delete this operator user?',
  },
  OperatorUserPageContainer: {
    InviteOperatorUser: 'Invite Operator User',
    Name: 'Name',
    Email: 'Email',
    Role: 'Role',
    Invite: 'Invite',
    OperatorUsers: 'Operator Users',
    Permissions: 'Permissions',
    Required: 'Required*',
    Submit: 'Submit',
    EmailError: 'Must be a valid email',
    EmailAddressPlaceholder: 'example@example.com',
    Select: 'Select',
    CreatedAt: 'Created At',
    DeleteInvitation: 'Delete',
    ResendEmail: 'Resend',
    InvitationSent: 'Invitation Sent',
    InvitationDeleted: 'Invitation Deleted',
    DeleteInvitationDialog: 'Are you sure you want to delete this invitation?',
    FilterPlaceholder: 'Filter operator users by...',
    NoRecords: 'No records to display',
    InviteTab: 'Invitations',
    OperatorUsersTab: 'Operator Users',
  },
  CreateAccountPage: {
    CreateAccount: 'Create An Account!',
    EmailAddress: 'Email Address',
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
    EmailAddressPlaceholder: 'example@example.com',
    PasswordPlaceholder: 'Password',
    ConfirmPasswordPlaceholder: 'Confirm Password',
    Register: 'Register',
    PasswordError: 'Password must be at least 12 characters',
    EmailError: 'Please enter A valid email',
    ConfirmPasswordError: 'Passwords must match',
    Required: 'Required*',
    Name: 'Name',
    NameError: 'Name must only contain letters',
    AcceptedInvite: 'You have already accepted an invitation.',
    ToLogin: 'To login, please click ',
    Here: 'here.',
    PasswordLowercase: 'Password must contain at least one lowercase letter.',
    PasswordUppercase: 'Password must contain at least one uppercase letter.',
    PasswordNumber: 'Password must contain at least one number.',
    PasswordSymbol: 'Password must contain at least one symbol.',
  },
  InviteOperatorUserListItem: {
    Delete: 'Delete',
    Resend: 'Resend',
    InvitationSent: 'Invitation sent',
    Email: 'Email',
  },
  StartTxDialogue: {
    TokenTitle: 'Enter Charging Token',
    EmailTitle: 'Enter User Email',
    Start: 'Start',
    EgToken: 'E.g. 04B0267AE05C39',
    EmailPhonePlaceHolder: 'Enter user email or phone',
    TokenCanNotBeEmpty: 'Token cannot be empty',
    EmailCanNotBeEmpty: 'Email cannot be empty',
    EnterValidEMailPhone: 'Enter Valid Email or Phone',
  },
  ReserveDialogue: {
    Reserve: 'Reserve',
    CanNotBeEmpty: 'Token cannot be empty',
    TokenTitle: 'Enter Charging Token',
    EmailTitle: 'Enter User Email',
    EgToken: 'E.g. 04B0267AE05C39',
    EgEmail: 'user@example.com',
    TokenCanNotBeEmpty: 'Token cannot be empty',
    EmailCanNotBeEmpty: 'Email cannot be empty',
    EnterValidEMail: 'Enter Valid Email',
    ReserveFor: 'Reserve for',
    FieldEmail: 'Email',
    FieldToken: 'Charging token uid',
  },
  ToasterMessages: {
    InvitationSuccess: 'Invitation sent successfully',
    CardUpdated: 'Card updated successfully',
    StationUpdated: 'Station updated',
    StationActivated: 'Station activated',
  },
  CardListItem: {
    Done: 'Done',
    Cancel: 'Cancel',
  },
  CardList: {
    deleteModalConfirm: 'Delete',
    deleteModalTitle: 'Confirm Delete',
    deleteModalText: 'Are you sure you want to delete this card?',
  },
  CardsPage: {
    FilterPlaceholder: 'Filter Cards by',
    ContractID: 'Contract ID',
    RFID: 'RFID',
    Type: 'Type',
    Status: 'Status',
    AddButton: 'Add',
    AddNewCard: 'Add Card(s)',
    Required: 'Required*',
    Submit: 'Submit',
    Or: 'Or',
    DragAndDrop: 'Drag and drop excel/csv file here',
    Disabled: 'Disabled',
    ErrorHasOccurred: 'An error has occurred',
    ChargingTokens: 'Charging Tokens',
    OngoingSessions: 'Ongoing Sessions',
    EmptySessions: 'No records to display',
  },
  OngoingSession: {
    Ongoing: 'Ongoing',
    Reserved: 'Reserved',
    Remaining: 'remaining',
    Charging: 'Charging',
    SuspendedEV: 'SuspendedEV',
    SuspendedEVSE: 'SuspendedEVSE',
    EVConnected: 'EV Connected',
  },
  AddCityModal: {
    Title: 'Add City',
    Subtitle: 'Please type the name of the city',
    AddButtonText: 'Add',
  },
  TransactionsReport: {
    PDF: 'Download as PDF',
    Excel: 'Download as Excel',
  },
  SiteTransactionsModal: {
    Title: 'Download Site Transactions',
    Subtitle: 'Export all transactions for {{site}} using the filters below.',
    FilterPlaceholder: 'Filter transactions by',
    Download: 'Download',
    Tooltip: 'Download site transactions',
  },
  StationsMap: {
    StationsView: 'Stations',
    StationsFilterPlaceholder: 'Filter sites by',
  },
  NotFound: {
    404: '404',
    NotFound: 'Not Found',
    RequestNotFound: " We're sorry, the page you requested could not be found",
    PleaseGoBack: 'Please go back to the home page',
    GoHome: 'GO HOME',
  },
  OCPPService: {
    TerminalSuccessMessage: 'Request Sent',
    ConnectorReserved: 'Connector Reserved',
    ReservationCancelled: 'Reservation Cancelled',
    SessionStarted: 'Session Started Successfully',
    SessionStopped: 'Session Stopped Successfully',
    ConnectorUnlocked: 'Connector Unlocked Successfully',
    HardResetSuccessful: 'Hard Reset Successful',
    SoftResetSuccessful: 'Soft Reset Successful',
    CacheCleared: 'Cache cleared successfully',
    DiagnosticsStatusNotification: 'Diagnostics refresh sent',
    ScheduledChangeAvailability:
      'Station scheduled change availability for connector(s) ',
    StatusUpdateRequested: 'Status Update Requested',
  },

  CancelConnectorReservation: {
    Title: 'Cancel Reservation',
    Subtitle:
      'Are you sure you want to cancel the reservation on this connector?',
    ButtonText: 'Confirm',
  },
  UploadDiagnosticsModal: {
    Refresh: 'Refresh',
    Diagnostics: 'Diagnostics',
    RequestDiagnostics: 'Request Diagnostics',
    lastUpdated: 'last updated',
  },
  ChargePointSaga: {
    RequestChargePointDiagnostics: 'Get diagnostics request sent',
    UpdateChargePointFirmware: 'Firmware update request sent',
  },
  TerminalModal: {
    Title: 'Terminal',
    ButtonText: 'Send',
    InvalidJson: 'Invalid json',
    Response: 'Response',
    Payload: 'Payload',
    Type: 'Type',
    NotAllowed: 'Required or Optional field values are not allowed',
  },
  ChargePointPrivacyToggle: {
    Public: 'Public',
    Private: 'Private',
  },
  ChargePointBlockToggle: {
    Blocked: 'Blocked',
    Active: 'Active',
  },
  ChargePointLogsToggle: {
    Live: 'Live',
  },
  TariffListItem: {
    ExpiryDate: 'Expires',
    ConsumedEnergy: 'Consumed Energy',
    Default: 'Default',
    Midnight: '12:00 am',
    CurrentTariff: 'Current Tariff',
    Tariffs: 'Tariffs',
    PointsCode: 'PTS',
  },
  TariffList: {
    Name: 'Name',
    Price: 'Price',
  },
  ScheduleList: {
    Rule: 'Rule',
  },
  AccessGroupList: {
    AccessGroupName: 'Name',
    NoOfTokens: 'No. of Tokens',
  },
  ChargepointSpecs: {
    NoAccessGroups: 'No access groups here',
    NoTariffs: 'No tariffs here',
    NoPrivacyRules: 'No schedule here',
    PublicStationsCaution: 'Not applied to public stations',
  },
  UserTransaction: {
    ConnectorType: 'Connector Type',
    ConnectorID: 'Connector ID',
    ReservationID: 'Reservation ID',
    Tariff: 'Tariff',
    ChargingLevel: 'Charging Level',
    TariffText: 'Tariff',
    Start: 'Start',
    End: 'End',
    Duration: 'Duration',
    TokenType: 'Token Type',
    Reverse: 'Reverse',
    ReverseTitle: 'Reverse Charging Transaction',
    Submit: 'Submit',
    SuccessReverseTransaction: 'Transaction reversed successfully',
  },
  ChargePointSpecsEdit: {
    Tariffs: 'Tariffs',
    AccessGroups: 'Access Groups',
    Schedule: 'Schedule',
  },
  AddChargingTokensModal: {
    AddNewCard: 'Add Charging Token(s)',
    Next: 'Next',
    Required: 'Required*',
    Submit: 'Submit',
    Or: 'Or',
    DragAndDrop: 'Drag and drop excel/csv file here',
    FileNotSupported: 'File format not supported',
    UploadedFile: 'Uploaded file',
    ContractID: 'Contract ID',
    Reference: 'Reference',
    Serial: 'Serial',
    Type: 'Type',
    Status: 'Status',
  },
  CardDetails: {
    AccessGroups: 'Access Groups',
    FilterLogsBy: 'Filter Logs By',
    DeleteCard: 'Delete Card',
    DeleteCardSubtitle: 'Please type the Card uid to confirm deletion',
    DeleteButtonText: 'Delete',
    ChargingTokenUpdated: 'Charging Token Updated',
    FilterOperatorUserActionsBy: 'Filter Operator User Actions by',
    UsageStats: 'Usage',
    Energy: 'Energy',
    Cost: 'Cost',
    Sessions: 'Sessions',
    NoUsageData: 'No usage in this period',
    UsageStatsError: 'Could not load usage data',
    Last7Days: 'Last 7 days',
    Last30Days: 'Last 30 days',
    Last90Days: 'Last 90 days',
    ThisMonth: 'This month',
    MaxRangeWarning: 'You can select a range of up to 3 months',
  },
  StationUptimeMonitor: {
    ResetButtonText: 'Reset Graph',
    Title: 'Uptime Monitor',
    NoData: 'No data to show',
  },
  ConnectorUtilization: {
    ResetButtonText: 'Reset Graph',
    Title: 'Connectors Utilization',
    NoData: 'No data to show',
    Minutes: 'Min',
  },
  StationUptimePieChart: {
    UptimeStatus: {
      Online: 'Online',
      Offline: 'Offline',
      Unstable: 'Unstable',
    },
  },
  RequestDiagnosticsModal: {
    RequestDiagnosticsTitle: 'Request Diagnostics',
    SendRequest: 'Send Request',
    Date: 'Date (Optional)',
  },
  AlertModal: {
    Title: 'Alerts',
    Edit: 'Edit',
    Cancel: 'Cancel',
    Done: 'Done',
    NoAlertsAvailable: 'No Alerts Available',
  },
  LocalListModal: {
    CurrentVersion: 'Current Version',
    LocalAuthorizationList: 'Local Authorization List',
    LocalList: 'Local List',
    UpdateType: 'Update Type',
    AddLocalList: 'Add Local List',
    SendLocalList: 'Send Local List',
    LocalListEmpty: 'Local List Empty',
    ExpiryDate: 'Expiry Date',
    LocalListUpdated: 'Local List Updated',
  },
  ChargingProfile: {
    MaxCurrent: 'Max Current',
    ClearProfile: 'Remove Profile',
    RemoveChargingProfileTitle: 'Remove Charging Profile',
    RemoveChargingProfileSubtitle:
      'Are you sure you want to remove this charging profile?',
    ActionButton: 'Remove',
  },
  ChargingSchedulePeriod: {
    From: 'From:',
    To: 'To',
    A: 'A',
    MaxCurrent: 'Max Current:',
    OnePhase: '1-phase:',
    ThreePhase: '3-phase:',
  },
  ChargingScheduleModal: {
    Title: 'Set Charging Profile',
    NamePlaceHolder: 'Profile Name',
    Name: 'Name',
    MaxCurrent: 'Max Current',
    Send: 'Send',
  },
  ChargingProfileModal: {
    Title: 'Charging Profile Details',
    NoCompositeSchedule: 'No Composite Schedule',
    CreateProfile: 'Create Profile',
    CompositeSchedule: 'Composite Schedule',
  },
  IFTable: {
    TryAgain: 'Retry',
    TryAgainText: "Couldn't load data",
  },
  OperatorUserProfile: {
    ModalTitle: 'Operator User Profile',
    logout: 'Logout',
    ChangePassword: 'Change Password',
    CurrentPassword: 'Current Password',
    NewPassword: 'New Password',
    ConfirmNewPassword: 'Confirm New Password',
    Email: 'Email',
    Role: 'Permissions',
    JoinedOn: 'Joined On',
    Countries: 'Country',
    Password: 'Password',
    ConfirmChangePassword: 'Confirm',
    Required: 'Required*',
    MinLength: 'Password must be at least 12 characters',
    PasswordsMustMatch: 'Passwords do not match',
    ChangePasswordSuccessMessage: 'Password changed Successfully',
    EditUserNameTitle: 'Edit User Name',
    EditUserNameLabel: 'User Name',
    EditUserNameConfirm: 'Confirm',
    ChangeUserNameSuccessMessage: 'User Name changed Successfully',
    Actions: 'Actions',
    ActionsFilterPlaceHolder: 'Filter actions by',
    SaveRole: 'Save',
    EditRole: 'Edit',
    DeleteRole: 'Delete',
    CancelEdit: 'Cancel',
    Unblock: 'Unblock',
    Blocked: 'Blocked',
    UnblockSuccess: 'Operator user unblocked',
    unblockModalTitle: 'Unblock Operator User',
    unblockModalText:
      'Are you sure you want to unblock this operator user? They will be able to log in again immediately.',
    unblockModalConfirm: 'Unblock',
    deleteModalText: 'Are you sure you want to delete this Operator user?',
    deleteModalConfirm: 'Delete',
    deleteModalTitle: 'Confirm Delete',
    UpdateMessage: 'Operator user updated',
    InviteSuccess: 'Invitation sent',
    DeleteSuccess: 'Operator User Deleted',
    NameChange: 'Name Updated',
    PasswordChange: 'Password Updated',
    PasswordLowercase: 'Password must contain at least one lowercase letter.',
    PasswordUppercase: 'Password must contain at least one uppercase letter.',
    PasswordNumber: 'Password must contain at least one number.',
    PasswordSymbol: 'Password must contain at least one symbol.',
  },

  TransactionEvents: {
    StatusOverTime: 'Status Over Time',
    PowerOverTime: 'Power Over Time',
    ChargingStatistics: 'Charging Statistics',
    Power: 'Power (kW)',
    Ampere: 'Ampere (A)',
    ChargingProgress: 'Charging Progress',
    Voltage: 'Voltage (V)',
    ChargingSessionDetails: 'Charging Session Details',
    TransactionId: 'Transaction ID',
    Connector: 'Connector',
    Started: 'Started',
    Ended: 'Ended',
    Duration: 'Duration',
    ChargingToken: 'Charging Token',
    Reservation: 'Reservation',
    TariffConsumption: 'Tariff Consumption',
    Tariff: 'Tariff',
    TariffAvg: 'Average Tariff ',
    TotalCost: 'Total Cost',
    TotalEnergy: 'Total Energy (kWh)',
    Percentage: '%',
    ChargingAnalytics: 'Charging Analytics',
  },
  ChargingEventsModal: {
    Title: 'Charging Analytics',
    ChargingEvents: ' Charging Events',
    StationLogs: 'Station Logs',
    SessionEnded: 'Ended',
  },
  OperatorAlertList: {
    Name: 'Name',
    OperatorUsers: 'Operator Users',
    ChargePoints: 'Charge Points',
    ChargePointsStatus: 'Charge Points Status',
    Type: 'Type',
    Settings: 'Settings',
    OperatorAlertDetails: 'Alert Details',
    Active: 'Active',
    Inactive: 'Inactive',
    OperatorAlertsStatus: 'Alert Status',
    FirstPart: 'This alert sends a notification via ',
    SecondPart: 'whenever a charge point remains ',
    ThirdPart: 'continuously for ',
    FourthPart: 'minutes, and automatically repeats every',
    Hours: 'hours',
    AlertSettings: 'Settings',
    Duration: 'Duration',
    RepeatAfter: 'Repeat After',
    PercentageAffected: 'Percentage Affected',
    Interval: 'Interval',
    DisableAfter: 'Disable After',
    Global: 'Global',
    Status: 'Status',
    MoreThan: '> ',
    percentage: '%',
    Minutes: ' minutes',
    TypePopover: 'Select the notification channel for this alert',
    StatusPopover: 'Select the charge point statuses that trigger this alert.',
    DurationPopover:
      'Minimum continuous time a charge point must remain in the selected statuses before this alert triggers.',
    RepeatAfterPopover:
      'Time after which this alert repeats if the charge point remains in the selected statuses.',
    GlobalPopover:
      'If enabled, this alert applies to all charge points in the system. If disabled, it only applies to the selected charge points.',
    PercentageAffectedPopover:
      'Percentage of charge points that must be in the tracked status for the alert to be triggered',
    IntervalPopover: 'How often the alert job is triggered',
    Edit: 'Edit',
    Delete: 'Delete',
    Cancel: 'Cancel',
    Save: 'Save',
    ExcludeChargePoints: 'Excluded Charge Points',
    deleteModalCancel: 'Cancel',
    deleteModalConfirm: 'Delete',
    deleteModalTitle: 'Confirm Delete',
    deleteModalText: 'Are you sure you want to delete this alert?',
    NameMustBeAtLeastN: 'Name must be at least {{n}} characters',
    Required: 'Required*',
    MustBeNumber: 'Must be a number',
    Yes: 'Yes',
    No: 'No',
    NumberExample: 'Ex. 15...',
  },
  ChargePointList: {
    NoChargePoints: 'No Charge Points here',
    ChargePointName: 'Charge Point Name',
    ChargePointID: 'Charge Point ID',
    NoChargePointsFound: 'No Charge Points found',
  },
  OperatorAlertsPage: {
    Title: 'Operator Alerts',
    FilterPlaceholder: 'Filter alerts by',
    Add: 'Add',
  },
  Analytics: {
    ChargingSessions: 'Charging Sessions',
    Consumed: 'Consumed',
    AverageConsumption: 'Average Consumption',
    AverageDuration: 'Average Duration',
    KiloWattHour: 'kWh',
    KiloWatt: 'kW',
    Hours: 'hours',
    OverviewCurrent: 'Current',
    OverviewPrevious: 'Previous',
    AverageDurationTitle: 'Avergae session duration',
    Dc: 'DC',
    Ac: 'AC',
    Minimum: 'min: ',
    Maximum: 'max: ',
    Transaction: ' transactions',
    Revenue: 'Transaction Revenue',
    SinceSentance: 'since last month',
    AverageRevenue: 'average / charge',
    EGP: 'EGP',
    Co2: 'Co2 save',
    Kg: 'kg',
    Emitted: 'emiited',
    CarbonFootprint: 'Carbon footprint reduction',
    Co2Saved: 'Co2 saved',
    FuelSaved: 'Fuel saved',
    FootprintBody: 'charged this month',
    Connectors: 'Connectors used',
    Charged: 'kWh charged',
    Time: 'Time charged',
    TransactionsCard: 'Transactions',
    ChargingStations: 'Charging Stations',
    TotalConnectors: 'Connectors',
    PeakHour: 'Peak hour heatmap',
    Session: 'session',
    TopSites: 'Top Sites',
    StationName: 'Station Name',
    NumberOfTransactions: 'Transactions count',
    EnergyConsumption: 'Energy Consumption (kWh)',
    Utilization: 'Utilization',
    TokensStats: 'Charging Tokens Statistics',
    TokensAdded: 'Tokens added',
    TokensConsumption: 'Tokens average consumption',
    TokensCount: 'Tokens count',
    AverageTokens: 'average / day',
    MaxConsumption: 'token max consumption',
    Virtual: 'Virtual',
    Rfid: 'RFID',
    Tokens: 'token',
    RevenueTrend: 'Revenue and transaction trend',
    TokenActivity: 'Charging tokens activity',
    LastYear: 'Last year',
    LastMonth: 'Last month',
    Last3Months: 'Last 3 months',
    Last6Months: 'Last 6 months',
    LastWeek: 'Last week',
    ThisYear: 'This year',
    TopCities: 'Top Active Cities',
    SitesCount: 'Sites count',
    City: 'City',
    SinceLast3Months: 'since previous 3 months',
    SinceLast6Months: 'since previous 6 months',
    SinceLastMonth: 'since previous month',
    SinceThisMonth: 'since previous month',
    SinceLastYear: 'since previous year',
    SinceThisYear: 'since previous year',
    Overview: 'Overview',
    EnergyConsumption: 'Consumption',
    Utilization: 'Utilization',
    AllTime: 'All Time',
    TransactionsStats: 'Transactions Statistics',
    ThisMonth: 'This Month',
  },
  TariffList: {
    Name: 'Name',
    NotSet: '—',
    UUID: 'UUID',
    MinPrice: 'Min Price',
    MaxPrice: 'Max Price',
    Type: 'Type',
    StartDate: 'Start Date',
    ExpiryDate: 'Expiry Date',
    Elements: 'Elements',
    UUIDTitle: 'UUID',
    PriceComponent: 'Price Component',
    Restrictions: 'Restrictions',
    NoRestrictions: '—',
    Dash: '—',
    Step: 'Step',
    kWh: 'kWh',
    Vat: 'VAT',
    MinPower: 'Min Power',
    MaxPower: 'Max Power',
    MinEnergy: 'Min Energy',
    MaxEnergy: 'Max Energy',
    MinDuration: 'Min Duration',
    MaxDuration: 'Max Duration',
    MinParkingDuration: 'Min Parking Duration',
    MaxParkingDuration: 'Max Parking Duration',
    MinCurrent: 'Min Current',
    MaxCurrent: 'Max Current',
    EndDate: 'End Date',
    StartTime: 'Start Time',
    EndTime: 'End Time',
    PowerUnit: 'WH',
    EnergyUnit: 'KWh',
    CurrentUnit: 'A',
    Percentage: '%',
    Min: 'Min',
    Sec: 'Sec',
    DaysOfWeek: 'Days Of Week',
    Reservation: ' Reservation',
  },
  TariffModal: {
    CreateTitle: 'Create Tariff',
    EditTitle: 'Edit Tariff',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    StartTime: 'Start Time (Inc)',
    EndTime: 'End Time (Exc)',
    Energy: 'Energy (kWh)',
    Current: 'Current (A)',
    Power: 'Power (kW)',
    Duration: 'Duration (min)',
    ParkingDuration: 'Parking Duration (sec)',
    Restrictions: 'Restrictions',
    Min: 'Min',
    Max: 'Max',
    DaysOfWeek: 'Days of Week',
    Reservation: 'Reservation',
    Invalid: 'Invalid',
    PriceComponent: 'Price Component(s)',
    Type: 'Type',
    VAT: 'VAT (%)',
    Vat: 'VAT',
    Price: 'Price',
    StepSize: 'Step Size',
    AddPriceComponent: 'Add Price Component',
    Required: 'Required*',
    AddElement: 'Add Element',
    Elements: 'Element(s)',
    Required: 'Required*',
    Elements: 'Element(s)',
    Required: 'Required*',
    Name: 'Name',
    StartDate: 'Start Date',
    ExpiryDate: 'Expiry Date',
    MinPrice: 'Min Price',
    MaxPrice: 'Max Price',
    ExclVat: 'Excl. VAT',
    InclVat: 'Incl. VAT',
    Create: 'Create',
    TariffToast: 'Tariff created successfully',
    Save: 'Save',
    Delete: 'Delete',
    TariffUpdateToast: 'Tariff updated successfully',
    TariffDeleteToast: 'Tariff deleted successfully',
    deleteModalTitle: 'Confirm Delete',
    deleteModalText: 'Are you sure you want to delete this tariff?',
    deleteModalConfirm: 'Delete',
    NotSet: '—',
  },
  TariffPage: {
    Create: 'Create Tariff',
    Title: 'Tariffs',
    FilterPlaceholder: 'Filter tariffs by',
  },
  TariffPopOverContainer: {
    InfoText: 'Go to the Tariffs page to view all tariff restrictions.',
    EnergyUnit: 'kWh',
    AmpereUnit: 'A',
    PowerUnit: 'kW',
    Min: 'Min',
    Max: 'Max',
    Reservation: ' Reservation',
  },
  CostBreakdown: {
    Title: 'Cost Breakdown',
    Type: 'Type',
    TypeEnergy: 'Energy',
    TypeTime: 'Time',
    TypeParkingTime: 'Parking Time',
    TypeFlat: 'Flat',
    Volume: 'Volume',
    Rate: 'Rate',
    Amount: 'Amount',
    ExclVat: 'Excl. VAT',
    InclVat: 'Incl. VAT',
    Subtotal: 'Subtotal',
    Vat: 'VAT',
    Total: 'Total',
  },
  ChargingPeriodAccordion: {
    ChargingPeriod: 'Charging Period',
    StartTime: 'Start Time',
    Time: 'Time (h)',
    Power: 'Power (kW)',
    StateOfCharge: 'State of Charge',
    Energy: 'Energy (kWh)',
    Current: 'Current (A)',
    ParkingTime: 'Parking Time (h)',
  },
}

export default en
